export default __webpack_public_path__ + "static/media/dm_dich_vu.86a34f77.xlsx";